import React from "react";
import { Heading, Text } from "@chakra-ui/layout";
import { Baner } from "./styled";

export const MobileBaner = () => {
  return (
    <Baner>
      <Heading>TREE SERVICE</Heading>
      <Text> Wycinka i pielęgnacja drzew</Text>
    </Baner>
  );
};
